import React, { Component } from "react";
import BlogInfo from "./BlogInfo";
import LatestArtice from "./LatestArtice";
import ArticleList from "./ArticlesList";

export default class BlogItems extends Component {
  render() {
    const articleList = BlogInfo.map(item => (
      <ArticleList key={item.id} item={item} />
    ));

    return (
      <div>
        <div className="blog-parallax parallax d-flex justify-content-center align-items-center">
          <h1 className="main-photo-text">Blog</h1>
        </div>
        <div className="container">
          <section className="row">
            <div className="col-12 card my-2">
              <LatestArtice />
            </div>
            <div className="col-12 card">
              <div className="row">{articleList}</div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}
